import { Outlet, useLocation } from 'react-router-dom';

import { Link } from 'react-router-dom';
import {
  pagesConfig,
  resourceCalendarDetailPages,
} from '../../../shared/pages-config';

import { isAbleToSeeUIElement } from '../../../utils/roles/client-roles';

import { useUserSettings } from '../../../utils/use-user-settings';
import SimpleBreadcrumbsPage from '../../../shared/simple-breadcrumbs-page';
import { ModuleList } from '../../../shared/analytics/module-list';
import { Messages } from '../../../utils/message-constants';
import { useRouteMatch } from '../../../shared/useRouteMatch';

import SharedTabCard from '../../../shared/shared-tab-card';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Tooltip from '@mui/material/Tooltip';

export default function ResourceCalendarsDetails() {
  const { calendarRoles, administrationRoles, usersTier, isDefault } =
    useUserSettings();

  const location = useLocation();
  const pathNumber = location.pathname.split('/').length;
  const tabsValue =
    pathNumber === 4
      ? location.pathname.split('/')[2]
      : pathNumber > 2
      ? location.pathname.split('/').pop()
      : pagesConfig.resourceCalendars.link;

  const shouldAllowHeightToScroll =
    tabsValue === pagesConfig.resourceDefaults.link;

  const isFormPage = useRouteMatch([
    `${pagesConfig.resourceCalendars.link}/${pagesConfig.createResourceCalendar.link}`,
    `${pagesConfig.resourceCalendars.link}/${pagesConfig.editResourceCalendar.link}`,
  ]);

  if (isFormPage) return <Outlet />;

  return (
    <SimpleBreadcrumbsPage
      bookmarkKey={pagesConfig.resourceCalendarsLayout.value}
      breadcrumbs={[
        { label: ModuleList.modules.calendars.name },
        { label: pagesConfig.resourceCalendars.name },
      ]}
      topContent={
        <SharedTabCard>
          <Tabs
            value={tabsValue}
            variant="scrollable"
            allowScrollButtonsMobile
            scrollButtons={false}
            sx={{
              mx: 1,
              '& .MuiTabs-flexContainer': {
                marginTop: '6px',
              },
              '.MuiTabs-scrollButtons.Mui-disabled': {
                opacity: 0.3,
              },
            }}
          >
            {resourceCalendarDetailPages.map((page) => {
              const doesntHavePermission =
                !isAbleToSeeUIElement(
                  page.roleGroup === 'calendarRoles'
                    ? calendarRoles
                    : administrationRoles,
                  page.requiredPermission
                ) && page.requiredPermission !== '*';

              const doesntHaveTier = usersTier.rank < page.minimumTier;
              const shouldShowButDisabled = isDefault && doesntHaveTier;
              if (shouldShowButDisabled) {
                return (
                  <Tab
                    key={page.name}
                    value={page.link}
                    component={Link}
                    to={page.link}
                    label={
                      <Tooltip
                        title={Messages.Errors.Tier.Viewing(
                          page.minimumTierDisplayValue
                        )}
                        onClick={(e) => e.preventDefault()}
                        arrow
                      >
                        <span style={{ pointerEvents: 'auto' }}>
                          {page.name}
                        </span>
                      </Tooltip>
                    }
                    icon={<page.icon />}
                    iconPosition="start"
                    sx={{
                      minHeight: '40px',
                      height: '40px',
                      width: 'fit-content',
                    }}
                    disabled
                  />
                );
              }

              return (
                !(doesntHavePermission || doesntHaveTier) && (
                  <Tab
                    key={page.name}
                    value={page.link}
                    component={Link}
                    to={page.link}
                    label={page.name}
                    icon={<page.icon />}
                    iconPosition="start"
                    sx={{
                      minHeight: '40px',
                      height: '40px',
                      width: 'fit-content',
                    }}
                  />
                )
              );
            })}
          </Tabs>
        </SharedTabCard>
      }
      heightOfTopContent={58}
      shouldAllowHeightToScroll={shouldAllowHeightToScroll}
      isSubTabs
    >
      <Outlet />
    </SimpleBreadcrumbsPage>
  );
}
